
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SessionHistoryEntry {
  consumption_id: string;
  booking_id: string;
  booking_date: string;
  time_slot: string;
  workout_type_name: string;
  consumption_type: 'completed' | 'missed';
  consumption_date: string;
  notes: string | null;
  created_at: string;
  is_cycle_start?: boolean;
}

interface UseClientSessionHistoryParams {
  clientId: string;
  limit?: number;
  offset?: number;
}

export const useClientSessionHistory = ({ 
  clientId, 
  limit = 50, 
  offset = 0 
}: UseClientSessionHistoryParams) => {
  return useQuery({
    queryKey: ['session-history', clientId, limit, offset],
    queryFn: async (): Promise<SessionHistoryEntry[]> => {
      console.log('Fetching session history for client:', clientId);
      
      // Use the REST API endpoint for the custom function
      const { data, error } = await supabase
        .rpc('get_client_session_history', {
          p_client_id: clientId,
          p_limit: limit,
          p_offset: offset
        });

      if (error) {
        console.error('Error fetching session history:', error);
        throw new Error(error.message);
      }

      console.log('Session history fetched successfully:', data);
      return data || [];
    },
    enabled: !!clientId,
  });
};
